import { relatedActionsIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const MoreH = createIcon({
  displayName: 'MoreH',
  paths: [
    'M170.667 597.333c-47.104 0-85.333-38.229-85.333-85.333s38.229-85.333 85.333-85.333c47.104 0 85.333 38.229 85.333 85.333s-38.229 85.333-85.333 85.333zM426.667 512c0 47.104 38.229 85.333 85.333 85.333s85.333-38.229 85.333-85.333c0-47.104-38.229-85.333-85.333-85.333s-85.333 38.229-85.333 85.333zM768 512c0 47.104 38.229 85.333 85.333 85.333s85.333-38.229 85.333-85.333c0-47.104-38.229-85.333-85.333-85.333s-85.333 38.229-85.333 85.333z'
  ],
  canvasPaths: canvasIconPaths(relatedActionsIcon)
})
